export const billingPlaceholders = {
  firstName: "assignPopup.newCustomer.placeholders.firstName",
  lastName: "assignPopup.newCustomer.placeholders.lastName",
  address: "assignPopup.newCustomer.placeholders.address1",
  city: "account.businessAddress.city",
  state: "assignPopup.newCustomer.placeholders.state",
  postal: "assignPopup.newCustomer.placeholders.postal",
  country: "assignPopup.newCustomer.placeholders.country",
  email: "assignPopup.newCustomer.placeholders.email",
  accountNumber: "paymentPopup.accountNumber",
  routingNumber: "paymentPopup.routingNumber",
  cardNumber: "paymentPopup.cardNumber",
  cardExpiryMonth: "paymentPopup.cardExpiryMonth",
  cardExpiryYear: "paymentPopup.cardExpiryYear",
  cardExpiry: "paymentPopup.cardExpiry",
  cardCvv: "paymentPopup.cardCvv",
}
